"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var ap_1 = tslib_1.__importDefault(require("./ap"));
var pc_1 = tslib_1.__importDefault(require("./pc"));
var je_1 = tslib_1.__importDefault(require("./je"));
var check_1 = tslib_1.__importDefault(require("./check"));
var bank_1 = tslib_1.__importDefault(require("../system/bank"));
var TransactionExportResource = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionExportResource, _super);
    function TransactionExportResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransactionExportResource.endpoint = '/exports';
    TransactionExportResource.MODEL_NAME = 'transactionexport';
    TransactionExportResource.related = {
        bank: bank_1.default,
        accountspayable: ap_1.default,
        pettycash: pc_1.default,
        journalentry: je_1.default,
        papercheck: check_1.default,
    };
    return TransactionExportResource;
}(base_1.default));
exports.default = TransactionExportResource;
//# sourceMappingURL=exports.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/exports.js
// module id = ja64
// module chunks = 0